import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        label: 'id',
        key: 'ID',
    },
    {
        label: 'providerName',
        key: 'PROVIDER_NAME',
    },
];
